/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Seccion_Home from "./Secciones/Seccion_Home";
import Barra from "./Barra/Barra";
import Footer from "./Footer";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Seccion_Proyecto from "./Secciones/Seccion_Proyecto";
import Seccion_Documentacion from "./Secciones/Seccion_Documentacion";


const Pagina = () => {

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Router>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{zIndex: 2}}>
                    <Barra/>
                </Grid2>

                <Routes>
                    <Route path={"*"} element={<Seccion_Home/>}/>
                    <Route path={"/"} element={<Seccion_Home/>}/>
                    <Route path={"/:id"} element={<Seccion_Home/>}/>
                    <Route path={"/Home"} element={<Seccion_Home/>}/>
                    <Route path={"/Documentacion"} element={<Seccion_Documentacion/>}/>
                </Routes>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 8}}>
                    <Footer/>
                </Grid2>

            </Router>

        </Grid2>
    )

}
export default Pagina